import {Injectable, signal} from '@angular/core';
import {ProductCardImage} from "../types/product-card-image.types";

@Injectable({
  providedIn: 'root'
})
export class ProductCardImagesStateService {
  private _productCardImagesState = signal<Array<ProductCardImage>>([]);
  public productCardImagesState = this._productCardImagesState.asReadonly();

  public updateFilesData(productCardImage: ProductCardImage): void {
    this._productCardImagesState.update(current => {
      const newValue = [...current];
      newValue.push(productCardImage);

      return newValue;
    });
  }

  public deleteFilesData(id: number): void {
    this._productCardImagesState.update(current => {
      return current.length ?
        current.filter(item => item.id !== id) :
        [];
    });
  }

  public resetFilesData(): void {
    this._productCardImagesState.set([]);
  }
}
